// @ts-nocheck
import React, { useState, useEffect } from 'react';
import Router, { useRouter } from 'next/router';
import { useQuery } from '@tanstack/react-query';
import Fetch from '@/utils/Fetch';
import QuoteDetail from '@/components/customer-zone/quote/quote-detail';
import QuoteItems from '@/components/customer-zone/quote/quote-items';
import QuoteTotals from '@/components/customer-zone/quote/quote-totals';
import { colors, layout, shadows } from '@/theme/';
import ButtonDropdown from '@/components/button-dropdown';
import DownloadService from '@/utils/download-service';
import Breadcrumbs from "@/components/breadcrumbs";
import Storage from '@/utils/storage';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import { createFileRoute } from '@tanstack/react-router'

function ViewQuote() {
  const router = useRouter();
  const { id } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

  const { data: quote } = useQuery(
    ['quote', id],
    () => Fetch.get({ url: `/Quote`, params: { id } }),
    { enabled: !!id }
  );

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  useEffect(() => {
    const subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  if (!quote) return null;

  const primaryContact = quote.Contact ? quote.Contact : undefined;
  const quoteLocation = quote.Location ? quote.Location : undefined;

  const exportDocument = (endPoint: any) => {
    DownloadService.downloadFile("GET", `/Quote/${endPoint}`, null, true, false);
  };

  const printOptions = [
    { text: 'Quote', link: `GetQuoteDocument?quoteID=${quote.ID}` }
  ];

  return (
    <div className="manage-container">
      <div className="row">
        <Breadcrumbs currPage={{ text: quote.QuoteNumber, link: `/quote/view/${quote.ID}`, type: 'view' }} />
      </div>
      <div className="row">
        <div className="contact">
          {primaryContact ?
            <>
              <div className="heading">{primaryContact.FirstName + " " + primaryContact.LastName}</div>
              <p>{quote.CustomerName}</p>
              <p>{primaryContact.MobileNumber}</p>
              <p>{primaryContact.EmailAddress}</p>
            </>
            : ""}
          <p>{quoteLocation ? quoteLocation.LocationDisplay : "No Location"}</p>
        </div>
        <div className="actions">
          <div className="button-dropdown">
            <ButtonDropdown
              disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess}
              action={exportDocument}
              text="Print"
              options={printOptions}
            />
          </div>
        </div>
      </div>
      <br />
      <QuoteDetail quote={quote} showPrint={false} showTotals={false} showHyperlink={false} />
      <br />
      <QuoteItems quoteItems={quote.QuoteItems} />
      <br />
      <QuoteTotals quote={quote} />

      <style jsx>{`
  
          .card {
              background-color: ${colors.white};
              border-radius: ${layout.cardRadius};
              box-shadow: ${shadows.card};
              box-sizing: border-box;
              padding: 1rem 2rem;
              position: relative;
              width: 100%;
          }
  
          .card h3 {
              margin-top: 0;
          }
            .row {
              display: flex;
            }
            .column {
              display: flex;
              flex-basis: 0;
              flex-direction: column;
              flex-grow: 1;
            }
            .column :global(.textarea-container) {
              height: 100%;
            }
            .column + .column {
              margin-left: 1.25rem;
            }
            .contact {
              color: ${colors.blueGrey};
              width: 100%;
              padding-right: 16px;
            }
            .contact h1 {
              color: ${colors.darkPrimary};
              font-size: 2rem;
              margin: 0 0 0.75rem;
            }
            .contact p {
              margin: 3px 0 0;
              opacity: 0.8;
            }
            .heading {
              color: ${colors.blueGrey};
              font-weight: bold;
            }
            .loader {
              border-color: rgba(113, 143, 162, 0.2);
              border-left-color: ${colors.blueGrey};
              display: block;
              margin-bottom: 1rem;
              margin-top: 1rem;
            }
            .comment {
              background-color: ${colors.white};
              border-radius: ${layout.cardRadius};
              box-sizing: border-box;
              color: ${colors.blueGrey};
              display: flex;
              flex-direction: column;
              justify-content: center;
              margin-top: 0.5rem;
              padding: 1.25rem 1rem;
              position: relative;
              width: 100%;
            }
            .comment-info {
              align-items: center;
              display: flex;
              margin-bottom: 4px;
            }
            .job {
              color: ${colors.bluePrimary};
              font-weight: bold;
            }
            .name {
              color: ${colors.darkPrimary};
              font-weight: bold;
            }
            .time {
              color: ${colors.blueGrey};
              font-size: 12px;
              margin-left: 1rem;
            }
            .text {
              white-space: pre-wrap;
            }
            .edit {
              margin-top: 0.2rem;
              margin-left: 1rem;
            }
            .status {
              position: absolute;
              right: 0;
              top: 0;
              width: 20rem;
            }
            .status :global(.input-container){
              background-color: ${colors.bluePrimary};
            }
            .status :global(input){
              color: ${colors.white};
            }
            .status :global(label){
              color: ${colors.white};
              opacity: 0.8;
            }
            .actions {
              display: flex;
              flex-direction: row;
            }
            .message-button-container {
              align-items: center;
              border: 1px solid ${colors.blueGreyLight};
              border-radius: ${layout.cardRadius};
              box-sizing: border-box;
              cursor: pointer;
              display: flex;
              font-weight: bold;
              height: 2.5rem;
              justify-content: space-between;
              margin-top: 0.5rem;
              padding: 0.5rem 0.5rem 0.5rem 0.5rem;
              position: relative;
              margin-right: 0.5rem;
            }
            .button-dropdown {
              width: 200px;
            }
         
        `}</style>
    </div>
  );
}

export default ViewQuote;

export const Route = createFileRoute('/_authenticated/quote/view/$id')({ component: ViewQuote })
